export function ViteIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="56" 
        height="56" 
        viewBox="0 0 56 56" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M55.7447 8.28853L29.4716 55.269C28.9291 56.2388 27.5356 56.2446 26.9848 55.2794L0.191032 8.29293C-0.408726 7.24096 0.490512 5.96687 1.68243 6.17978L27.9838 10.8811C28.1516 10.9111 28.3234 10.9108 28.491 10.8803L54.2423 6.18658C55.4302 5.97007 56.334 7.23456 55.7447 8.28853Z" 
          fill="url(#paint0_linear_vite)" 
        />
        <path 
          d="M40.5124 0.0138029L21.0696 3.82347C20.9143 3.85387 20.7734 3.93507 20.6692 4.05428C20.565 4.17349 20.5034 4.32395 20.4941 4.482L19.2982 24.6815C19.2702 25.1573 19.707 25.5265 20.1712 25.4194L25.5844 24.1703C26.091 24.0533 26.5486 24.4995 26.4445 25.0087L24.8363 32.8842C24.728 33.414 25.2256 33.8674 25.7432 33.7102L29.0866 32.6942C29.605 32.5369 30.103 32.9915 29.9934 33.5219L27.4377 45.8923C27.2777 46.666 28.3069 47.0878 28.7361 46.4245L29.0228 45.9815L44.8659 14.3638C45.1311 13.8344 44.6739 13.2309 44.0922 13.343L38.5204 14.4184C37.9966 14.5194 37.5512 14.0318 37.6989 13.5194L41.3357 0.912441C41.4836 0.399047 41.0366 -0.0889558 40.5124 0.0138029Z" 
          fill="url(#paint1_linear_vite)" 
        />
        <defs>
          <linearGradient 
            id="paint0_linear_vite" 
            x1="-0.463234" 
            y1="4.50056" 
            x2="32.2339" 
            y2="48.9059" 
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#41D1FF"/>
            <stop offset="1" stopColor="#BD34FE"/>
          </linearGradient>
          <linearGradient 
            id="paint1_linear_vite" 
            x1="26.4728" 
            y1="1.04798" 
            x2="32.3876" 
            y2="41.6226" 
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFEA83"/>
            <stop offset="0.0833" stopColor="#FFDD35"/>
            <stop offset="1" stopColor="#FFA800"/>
          </linearGradient>
        </defs>
      </svg>
    )
  }